var ViewQrCodeModalModule = /** @class */ (function () {
    function ViewQrCodeModalModule() {
    }
    return ViewQrCodeModalModule;
}());
export { ViewQrCodeModalModule };
